import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';

export default function LatestArticles() {
  const latest = [...allArticles].sort((a, b) => b.publishDate.localeCompare(a.publishDate)).slice(0, 8);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-12 gap-4">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-50 text-secondary-700 text-xs font-semibold mb-3">
              最新发布
            </span>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              最新文章
            </h2>
          </div>
          <Link
            to="/category/rumen-jiaocheng"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            全部文章 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {latest.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime} 分钟</span>
                </div>
                <h3 className="font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors text-sm mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{article.excerpt}</p>
                <div className="flex items-center gap-2 mt-3 text-xs text-foreground-400">
                  <i className="ri-calendar-line" />
                  <span>{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}